export default "__VITE_PUBLIC_ASSET__dda58a84__"